export interface ICreatePagePreviewInput {
  pageId: string;
  x: number;
  y: number;
}

class CreatePositionInput {
  public readonly pageId: string;
  public readonly x: number;
  public readonly y: number;

  constructor({ pageId, x, y }: { pageId: string; x: number; y: number }) {
    this.pageId = pageId;
    this.x = x;
    this.y = y;
  }

  public toJSON = () => ({
    pageId: this.pageId,
    x: this.x,
    y: this.y,
  });

  public static fromJSON = (json: ICreatePagePreviewInput): CreatePositionInput => {
    const { pageId, x, y } = Object.assign({}, json);

    if (typeof pageId !== 'string') throw new Error('.pageId must be a string');
    if (typeof x !== 'number') throw new Error('.x must be a number');
    if (typeof y !== 'number') throw new Error('.y must be a number');

    return new CreatePositionInput({
      pageId,
      x,
      y,
    });
  };
}

export default CreatePositionInput;
